import { render, staticRenderFns } from "./OtherPhone.vue?vue&type=template&id=f26aa300&scoped=true"
import script from "./OtherPhone.vue?vue&type=script&lang=js"
export * from "./OtherPhone.vue?vue&type=script&lang=js"
import style0 from "./OtherPhone.vue?vue&type=style&index=0&id=f26aa300&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f26aa300",
  null
  
)

export default component.exports